/* Keep the published Vorug support contacts actionable in native and dynamic content. */
(() => {
  const email = 'support@vorug.com';
  const phone = '+17208030932';
  const pattern = /support\s*@\s*vorug\s*\.\s*com|(?:\+?1[\s\u00a0\u202f().\u2010-\u2015-]*)?\(?720\)?[\s\u00a0\u202f.\u2010-\u2015-]*803[\s\u00a0\u202f.\u2010-\u2015-]*0932/gi;
  const excluded = 'a,script,style,noscript,template,svg,input,textarea,select,option,button,[contenteditable]:not([contenteditable="false"]),[hidden],[aria-hidden="true"],[data-vorug-contact-links-skip]';
  const matches = text => [...text.matchAll(pattern)].filter(match => {
    const before = text[match.index - 1] || '';
    const after = text[match.index + match[0].length] || '';
    return match[0].includes('@') ? !/[\w.+-]/.test(before) && !/^(?:[\w-]|\.+[\w-])/.test(text.slice(match.index + match[0].length)) : !/\d/.test(before + after);
  });
  function surface(anchor) {
    let node = anchor.parentElement;
    while (node) {
      const color = getComputedStyle(node).backgroundColor;
      const rgb = color.match(/[\d.]+/g)?.map(Number);
      if (rgb?.length >= 3 && (rgb.length === 3 || rgb[3] > .95)) {
        const channel = rgb.slice(0, 3).map(value => value / 255).map(value => value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4);
        const luminance = channel[0] * .2126 + channel[1] * .7152 + channel[2] * .0722;
        const mossLuminance = .15573707034913536;
        return (luminance + .05) / (mossLuminance + .05) >= 4.5 ? 'white' : 'paper';
      }
      node = node.parentElement;
    }
    return 'paper';
  }
  function decorate(anchor) {
    if (anchor.closest('script,style,template,[hidden],[aria-hidden="true"],[contenteditable]:not([contenteditable="false"]),[data-vorug-contact-links-skip]')) return;
    const href = anchor.getAttribute('href') || '';
    const contact = matches(anchor.textContent);
    const mail = /^mailto:\s*support@vorug\.com(?:\?|$)/i.test(href) || (contact.length === 1 && contact[0][0].includes('@'));
    const tel = /^tel:/i.test(href) && /^(?:1)?7208030932$/.test(href.replace(/\D/g, '')) || (contact.length === 1 && !contact[0][0].includes('@'));
    if (!mail && !tel && !/^(?:mailto|tel):/i.test(href)) return;
    if (mail || tel) {
      const query = mail && /^mailto:/i.test(href) && href.includes('?') ? href.slice(href.indexOf('?')) : '';
      const target = mail ? `mailto:${email}${query}` : `tel:${phone}`;
      if (href !== target) anchor.setAttribute('href', target);
      anchor.classList.add('vorug-contact-link');
      if (!anchor.classList.contains('vorug-contact-link--white') && !anchor.classList.contains('vorug-contact-link--paper')) anchor.classList.add(`vorug-contact-link--${surface(anchor)}`);
    }
    const arrowNode = anchor.querySelector('[data-contact-arrow],.vf-arrow,.icon-arrow,svg use[href*="arrow"]');
    const arrow = arrowNode?.closest('svg') || arrowNode;
    if (arrow) arrow.classList.add('vorug-contact-arrow');
    const walker = document.createTreeWalker(anchor, NodeFilter.SHOW_TEXT);
    let text;
    while (walker.nextNode()) if (walker.currentNode.nodeValue.trim()) text = walker.currentNode;
    if (text && /→\s*$/.test(text.nodeValue)) text.nodeValue = text.nodeValue.replace(/→(\s*)$/, '↗$1');
    anchor.classList.toggle('vorug-contact-link--has-arrow', !!arrow || /↗\s*$/.test(anchor.textContent));
  }
  function normalize(root) {
    if (!root || root.nodeType !== 1 || root.closest('script,style,template,input,textarea,select,[contenteditable]:not([contenteditable="false"]),[hidden],[aria-hidden="true"],[data-vorug-contact-links-skip]')) return;
    if (root.matches('a')) decorate(root);
    root.querySelectorAll('a').forEach(decorate);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const texts = [];
    while (walker.nextNode()) {
      const text = walker.currentNode;
      if (text.parentElement && !text.parentElement.closest(excluded) && matches(text.nodeValue).length) texts.push(text);
    }
    texts.forEach(text => {
      const fragment = document.createDocumentFragment();
      let offset = 0;
      matches(text.nodeValue).forEach(match => {
        fragment.append(document.createTextNode(text.nodeValue.slice(offset, match.index)));
        const anchor = document.createElement('a');
        anchor.textContent = match[0];
        anchor.href = match[0].includes('@') ? `mailto:${email}` : `tel:${phone}`;
        fragment.append(anchor);
        offset = match.index + match[0].length;
      });
      fragment.append(document.createTextNode(text.nodeValue.slice(offset)));
      const parent = text.parentElement;
      text.replaceWith(fragment);
      parent.querySelectorAll('a').forEach(decorate);
    });
  }
  const pending = new Set();
  let scheduled = false;
  function enqueue(node) {
    const root = node.nodeType === 3 ? node.parentElement : node;
    if (!root || root.nodeType !== 1 || !matches(root.textContent || '').length && !root.matches('a[href^="mailto:" i],a[href^="tel:" i]') && !root.querySelector('a[href^="mailto:" i],a[href^="tel:" i]')) return;
    pending.add(root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const roots = [...pending]; pending.clear();
      roots.filter(root => !roots.some(other => other !== root && other.contains(root))).forEach(normalize);
    });
  }
  const start = () => {
    normalize(document.body);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(enqueue);
      else enqueue(record.target);
    })).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['href', 'hidden', 'aria-hidden', 'open'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
